/* assets/bh-recently-viewed.js
   ───────────────────────────────────────────── */
(() => {
  const STORAGE_KEY = "bh_recently_viewed_v1";
  const MAX_STORE = 40;

  const uniq = (arr) => Array.from(new Set(arr.filter(Boolean)));

  function readStore() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch {
      return [];
    }
  }

  function writeStore(handles) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles.slice(0, MAX_STORE)));
    } catch {}
  }

  function pushCurrentHandle(currentHandle) {
    if (!currentHandle) return;
    const list = readStore();
    const next = uniq([currentHandle, ...list.filter((h) => h !== currentHandle)]);
    writeStore(next);
  }

  async function fetchFragment(handle) {
    const url = `/products/${encodeURIComponent(handle)}?sections=bh-product-card-fragment`;
    const res = await fetch(url, { credentials: "same-origin" });
    if (!res.ok) return null;

    const json = await res.json();
    const html = json["bh-product-card-fragment"];
    if (!html) return null;

    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    const item = tmp.querySelector(".resource-list__item");
    return item ? item.outerHTML : null;
  }

  function extractHandleFromItemHTML(html) {
    // 1) data-handle varsa
    const m1 = html.match(/data-handle="([^"]+)"/);
    if (m1 && m1[1]) return m1[1];

    // 2) /products/<handle> linkinden çek
    const m2 = html.match(/\/products\/([^"?#\s/]+)(?:[?#/"][^"]*)?/);
    if (m2 && m2[1]) return decodeURIComponent(m2[1]);

    return "";
  }

  function markSingleImageItems(containerEl) {
    // Kart içindeki img sayısı 1 ise hover swap kapatmak için class bas
    containerEl.querySelectorAll(".resource-list__item").forEach((item) => {
      const imgs = item.querySelectorAll("img");
      if (imgs.length <= 1) {
        item.classList.add("bh-rv-single-image");
      }
    });
  }

  async function hydrateSection(root) {
    const max = parseInt(root.getAttribute("data-max") || "8", 10) || 8;
    const currentHandle = (root.getAttribute("data-current-handle") || "").trim();

    // Product page ise track et
    pushCurrentHandle(currentHandle);

    const shell = root.querySelector("[data-bh-rv-shell]");
    if (!shell) return;

    // Horizon resource-list içindeki item host'u yakala
    const candidates = [
      shell.querySelector(".resource-list__items"),
      shell.querySelector("[data-resource-list-items]"),
      shell.querySelector(".resource-list"),
      shell,
    ].filter(Boolean);

    const itemsHost = candidates[0];
    if (!itemsHost) return;

    // Fallback item’ları (şu an DOM’da görünen randomlar) al
    const fallbackNodes = Array.from(itemsHost.querySelectorAll(".resource-list__item"));
    const fallbackHTML = fallbackNodes.map((n) => n.outerHTML);

    // Store’dan visited handle’ları al
    const all = readStore();
    const visitedHandles = all.filter((h) => h && h !== currentHandle).slice(0, max);

    // Visited yoksa: sadece fallback kalsın (ama tek görsel hover fix’ini uygula)
    if (!visitedHandles.length) {
      markSingleImageItems(itemsHost);
      return;
    }

    // Visited fragment'ları çek (order’ı koru)
    const visitedHTMLParts = await Promise.all(visitedHandles.map(fetchFragment));
    const visitedHTML = visitedHTMLParts.filter(Boolean);

    // Hiç çekemediysek fallback kalsın
    if (!visitedHTML.length) {
      markSingleImageItems(itemsHost);
      return;
    }

    // Duplicate handle’ları önlemek için visited set
    const visitedSet = new Set(
      visitedHTML.map(extractHandleFromItemHTML).filter(Boolean)
    );

    // Kalan slotları fallback’tan doldur (visited ile çakışanları at)
    const needed = Math.max(0, max - visitedHTML.length);
    let fillers = [];

    if (needed > 0 && fallbackHTML.length) {
      for (const html of fallbackHTML) {
        if (fillers.length >= needed) break;
        const h = extractHandleFromItemHTML(html);
        if (!h) continue;
        if (h === currentHandle) continue;
        if (visitedSet.has(h)) continue;
        fillers.push(html);
      }
    }

    // Yeni liste = visited + filler (toplam max adet)
    const merged = [...visitedHTML, ...fillers].slice(0, max);

    itemsHost.innerHTML = merged.join("");

    // Hover fix class’larını uygula
    markSingleImageItems(itemsHost);

    // Layout observer’ları tetikle
    window.dispatchEvent(new Event("resize"));
    document.dispatchEvent(
      new CustomEvent("bh:recently-viewed:hydrated", {
        detail: { sectionId: root.getAttribute("data-section-id") },
      })
    );
  }

  function boot() {
    document.querySelectorAll("[data-bh-recently-viewed]").forEach((root) => {
      hydrateSection(root);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }
})();